import { useState, useEffect } from 'react'

export const DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up',
  DOWN: 'down',
}

const MIN_DISTANCE_ON_SINGLE_SWIPE = 100 // px
const MAX_DISTANCE_AT_THE_TIME = 400 // px
const ALLOWED_TIME = 500 // ms

function useSwipe({ touchSurface, callback, config = {} }) {
  const [touchValues, setTouchValues] = useState({
    threshold: MIN_DISTANCE_ON_SINGLE_SWIPE, // required min distance traveled to be considered swipe
    restraint: MAX_DISTANCE_AT_THE_TIME, // maximum distance allowed at the same time in perpendicular direction
    allowedTime: ALLOWED_TIME, // maximum time allowed to travel that distance
    ...config,
  })

  const handleTouchStart = e => {
    const startValues = {
      direction: 'none',
      startX: e.changedTouches[0].pageX,
      startY: e.changedTouches[0].pageY,
      startTime: new Date().getTime(),
    }

    setTouchValues({
      ...touchValues,
      ...startValues,
    })
  }

  const handleTouchEnd = e => {
    const {
      startX,
      startY,
      allowedTime,
      startTime,
      threshold,
      restraint,
    } = touchValues

    let direction = null
    const travelDistX = e.changedTouches[0].pageX - startX // get horizontal dist traveled by finger while in contact with surface
    const travelDistY = e.changedTouches[0].pageY - startY // get vertical dist traveled by finger while in contact with surface
    const elapsedTime = new Date().getTime() - startTime // get time elapsed

    if (elapsedTime <= allowedTime) {
      // Horizontal check
      if (
        Math.abs(travelDistX) >= threshold &&
        Math.abs(travelDistY) <= restraint
      ) {
        direction = travelDistX < 0 ? DIRECTIONS.LEFT : DIRECTIONS.RIGHT // if dist traveled is negative, it indicates left swipe

      // Vertilcal check
      } else if (
        Math.abs(travelDistY) >= threshold &&
        Math.abs(travelDistX) <= restraint
      ) {
        direction = travelDistY < 0 ? DIRECTIONS.UP : DIRECTIONS.DOWN // if dist traveled is negative, it indicates up swipe
      }
    }

    if (callback) {
      callback(direction)
    }

    setTouchValues({
      ...touchValues,
      direction,
      startX: null,
      startY: null,
      startTime: null,
    })
  }

  useEffect(() => {
    touchSurface.addEventListener('touchstart', handleTouchStart, false)
    touchSurface.addEventListener('touchend', handleTouchEnd, false)

    return () => {
      touchSurface.removeEventListener('touchstart', handleTouchStart, false)
      touchSurface.removeEventListener('touchend', handleTouchEnd, false)
    }
  })

  return touchValues
}

export default useSwipe
